import request from '@/utils/request'
import Qs from 'qs'

/**
 * 获取当前登录用户信息
 */
export function getUserInfo() {
  return request({
    url: '/api/v1/user/info',
    method: 'get',
  })
}

/**
 * 获取产品和服务列表
 */
export function getProducts() {
  return request({
    url: '/api/v1/user/products',
    method: 'get',
  })
}

export function createSsoSt(service) {
  return request({
    url: '/api/v1/user/product/st',
    method: 'post',
    headers:{'Content-Type':'application/x-www-form-urlencoded'},
    data: Qs.stringify({service})
  })
}
